import type { UnwrapNestedRefs } from 'vue';
import type { MoviePlayerState } from 'src/models/moviePlayer';
import { getSensorDataOfMovieList } from 'src/lib/moviePlayerHelper';
import { dtFormat } from 'src/lib/dateHelper';

interface Deps {
  seekByTimeText: (seekTimeInfo: { dt: Date; dateDisp: string; timeDisp: string }) => Promise<void>;
}

interface MoviePlayerSensorChartContext {
  setSensorChartUIStateToDefault: () => void;
  openSensorChart: () => void;
  closeSensorChart: () => void;
  onSensorChartClick: (dt: Date) => void;
}

export function useMoviePlayerSensorChart(
  state: UnwrapNestedRefs<MoviePlayerState>,
  deps: Deps,
): MoviePlayerSensorChartContext {
  const setSensorData = (sensorData: typeof state.ui.sensorData) => {
    state.ui.sensorData = sensorData;
  };
  const setSensorChartUIStateToDefault = () => {
    setSensorData([]);
    state.ui.showSensorChart = false;
  };
  const getCurrentMovieListSensorData = async() => {
    if (!state.movieList.listSelection.currentMovieList) return;

    const sensorData = await getSensorDataOfMovieList(state.movieList.listSelection.currentMovieList);
    setSensorData(sensorData);
  };
  const openSensorChart = () => {
    state.ui.showSensorChart = true;
    if (state.ui.sensorData.length === 0) {
      getCurrentMovieListSensorData();
    }
  };
  const closeSensorChart = () => {
    state.ui.showSensorChart = false;
  };
  const onSensorChartClick = (dt: Date) => {
    if (!dt) return;

    dt = new Date(dt);
    const dateDisp = dtFormat(dt, 'yyyy/mm/dd');
    const timeDisp = dtFormat(dt, 'HH:MM:SS');
    deps.seekByTimeText({ dt, dateDisp, timeDisp });
  };

  return {
    setSensorChartUIStateToDefault,
    openSensorChart,
    closeSensorChart,
    onSensorChartClick,
  };
}
